import { ExportState, FiltersMap } from '@wix/bex-core';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Text } from '@wix/design-system';

export interface ExportStepCancelProps<T, F extends FiltersMap> {
  state: ExportState<T, F>;
}

function _ExportStepCancel<T, F extends FiltersMap>({
  state,
}: ExportStepCancelProps<T, F>) {
  const { translate: t } = state;
  return <Text widows>{t('cairo.export.cancelMessage')}</Text>;
}

export const ExportStepCancel = observer(_ExportStepCancel);
